import React from 'react';
import { IUIUrval } from '../../../Types/UrvalTypes';
import { IColumnDef } from '../../../Types/ColumnDefType';
import { FormStateRefType } from './StandardRutin';
import { DocumentNode } from 'graphql';
import { ApolloCache } from '@apollo/client';

export interface IStandardRutinContext {
  rutinID: number;
  collectionName: string;
  urval: IUIUrval | null;
  setUrval: React.Dispatch<React.SetStateAction<IUIUrval | null>>;
  columns: readonly IColumnDef[];
  setColumns: (newColumns: readonly IColumnDef[]) => void;
  formStateRef: FormStateRefType | null;
  setOpenChoiceDialog: (bool: boolean) => void;
  refetchButtonQueries: Array<DocumentNode | string>;
  urvalCacheInvalidation?: (cache: ApolloCache<object>) => void;
  /**
   * Adds query names to refetchButtonQueries that will be refetched when the refetch button is pressed
   * If query already exist in refetchButtonQueries, this function will do nothing */
  addRefetchButtonQuery: (
    refetchButtonQueries: Array<DocumentNode | string> | DocumentNode | string
  ) => void;
  selectNextDetail: React.MutableRefObject<((force?: boolean) => void) | null>;
}

const StandardRutinContext = React.createContext<IStandardRutinContext>({
  rutinID: 0,
  collectionName: '',
  urval: null,
  setUrval: () => {},
  columns: [],
  setColumns: () => {},
  formStateRef: null,
  setOpenChoiceDialog: () => {},
  refetchButtonQueries: [],
  addRefetchButtonQuery: () => {},
  selectNextDetail: React.createRef(),
});

export { StandardRutinContext };
